var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCurvedUpRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 461,
    viewBox: "0 0 465 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 457.5C45.1 461.5 13.1667 460.5 0 459.5V440H21.5C43 441 53.5 439.5 88 432.5C122.5 425.5 150 415.5 196 392C242 368.5 271.5 327 290.5 302C309.5 277 326 232 335.5 205C345 178 351 125 351 110.5V67.5L273 141.5L258.5 128.5L362.5 0L464.5 128.5L452.5 141.5L374.5 67.5C374.667 77.3333 374.9 99.7 374.5 110.5C374 124 371 166.5 360.5 203L360.202 204.037C353.182 228.449 342.168 266.753 315.5 307C302.012 327.355 282.128 349.205 261 370.5C197.754 434.244 96.3142 452.355 67.8391 457.439L67.5 457.5Z",
    fill: "#D1D5DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurvedUpRight);
export default __webpack_public_path__ + "static/media/arrow-curved-up-right.78b2f1b9fcedab38d8c1bd4b101dc000.svg";
export { ForwardRef as ReactComponent };